module.exports = __webpack_public_path__ + "static/coaching-a2d3532ab5d844f0de2015774b6e7b4e.jpg";